module.exports = __webpack_public_path__ + "static/media/purchase-order_icon_dark.3b961470.png";